
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Build from 'plaid-threads/Icons/Build';
import Key from 'plaid-threads/Icons/Key';
import Mobile from 'plaid-threads/Icons/Mobile';
import Rocket from 'plaid-threads/Icons/Rocket';
import Sandbox from 'plaid-threads/Icons/Sandbox';
import Transfer from 'plaid-threads/Icons/Transfer';
import Actions from '../../../../components/docs/Actions';
import DefinitionTable from '../../../../components/docs/DefinitionTable';
import TokenExchangeFlow from '../../../../components/docs/plaidoms/TokenExchangeFlow';
import Layout from '../../../../components/docs/Layout';
export const metadata = {
  noIndex: true,
  title: 'The Plaid Accelerate Network',
  section: 'Accelerate',
  toc: false,
  description: 'Access to capital and newtork service partners.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <Header title='The Plaid Accelerate Network' subtitle='' mdxType="Header" />
    <p>{`We know that one of the primary sources of underrepresentation in tech is
unequal access to capital. Furthermore, finding the right partners to grow your
business can be a crucial step in advancing your business. To address that,
we’ve put together a network of partners to help guide you through some best
practices around capital raising.`}</p>
    <Layout.Spacer units={2} />
    <h4 {...{
      "id": "capital-access-partners"
    }}>{`Capital Access Partners`}</h4>
    <p>{`Our Capital Access Partner network consists of Acrew, Accion, Andreessen
Horowitz, Harlem Capital, and Village Capital. Investors from each of these
firms will lead sessions with the cohort around specific fundraising topics.
These sessions are meant to be conversational and provide you with the
opportunity to ask questions and speak candidly with investors to prepare you
in your fundraising efforts. You can find an overview of the sessions below.
The series will culminate in a pitch practice session during which participants
will have the opportunity to pitch to or share their pitch deck with a panel of
investors and receive real-time feedback. You can find an overview of the
sessions below.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Milestone planning session with Village Capital`}</strong>{` - Understanding and
navigating your path to scale and the milestones you need to reach along the
way can be difficult. Join Village Capital for an hour long session on
milestone planning for growth. Learn about critical milestones, how they tie
into your fundraise strategy, and how to reach your next milestones.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Different types of VCs with Acrew`}</strong>{` - Join Acrew to learn about the
different types of Venture Capital firms and how to evaluate which firms are
the best fit for your business and fundraising objectives.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Investor Diligence with Harlem Capital`}</strong>{` - What are VCs really looking for
in an investment? In this session, Harlem Capital will offer a deep dive on
their diligence process, average investment amount and % ownership, and exit
expectations.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Financial Narratives with Village Capital`}</strong>{` - Join the Village Capital team
for a conversation around building a "financial narrative," including a broad
explanation of a startup's "financial story", which VilCap breaks down
into: Revenue Model, Unit Economics, Projections, and Fundraise Strategy.
The conversation will focus on diving deeper into the idea of trying to get
all these financial components to "tell the same story".`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Evaluating Term Sheets with Andreessen Horowitz`}</strong>{` - What should you look
for in a term sheet? The Andreessen Horowitz team will break down term
sheets, important elements to pay attention to, and how to evaluate term
sheets based on your desired fundraising outcome.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Pitch Best Practices with Accion`}</strong>{` - The Accion team will lead a session on
pitch best practices and how to refine your pitch based on your goals, the
kind of round you’re raising, and the types of investors you’re pitching to.`}</p>
      </li>
    </ul>
    <h5 {...{
      "id": "pitch-practice-day"
    }}>{`Pitch Practice Day`}</h5>
    <p>{`To conclude our Capital Access Partners event series, founders will have the
opportunity to receive feedback from a panel of investors who led sessions
throughout the program without the pressure of a true pitch or publicized demo
day. Founders can opt to practice their pitches with the panel or opt to spend
that time reviewing their pitch materials with the panel:`}</p>
    <ul>
      <li parentName="ul">{`Founders will select a format based on their needs: mock pitch or pitch deck
feedback session`}</li>
      <li parentName="ul">{`Out of respect for everyone's privacy and in the interest of time, each
founder will have an individual slot of 30 minutes to be used as follows:`}
        <ul parentName="li">
          <li parentName="ul">{`5 minute practice pitch + 20 minute feedback and Q&A`}</li>
          <li parentName="ul">{`30 minute deck feedback and Q&A session`}
            <ul parentName="li">
              <li parentName="ul">{`Founders participating in this option will send pitch materials in advance`}</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <Layout.Spacer units={4} />
    <h4 {...{
      "id": "service-partners"
    }}>{`Service partners`}</h4>
    <p>{`When building a company, it’s important to select vendors and service partners
that are stage appropriate, understand your use case, and will grow with you
and your business. Plaid has assembled a network of fintech startup-friendly
service providers to streamline the process of selecting vendors to partner
with. Additionally some providers offer special rates and discounts
specifically for Accelerate participants. Participants can access our `}<a parentName="p" {...{
        "href": "https://airtable.com/shr1o8bZK88PxSKGT"
      }}>{`partner
dealbook`}</a>{` to review participating
service providers and their Accelerate-offers. We will offer host sessions with
service partners where founders can learn more about the space they operate in
and ask questions about their products and services.`}</p>
    <h4 {...{
      "id": "leveraging-plaid-as-a-partner"
    }}>{`Leveraging Plaid as a Partner`}</h4>
    <p>{`While building on Plaid is by no means a requirement to participate in the
Plaid Accelerate program, if you decide to partner with us and use our technology,
we want to ensure that you have an exceptional and supportive experience`}</p>
    <p>{`Plaid Accelerate participants will be able to access the Plaid API at no cost
throughout the duration of the 5-month program. Following the program,
participants can continue using Plaid services for 3 years at discounted rates.
Please reach out to the Program Director to move forward with these rates and
meet your account management team who can support you as you build.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "capital-access-partners",
        level: 4,
        title: "Capital Access Partners",
      },
{
        id: "service-partners",
        level: 4,
        title: "Service partners",
      },
{
        id: "leveraging-plaid-as-a-partner",
        level: 4,
        title: "Leveraging Plaid as a Partner",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
